import { SubscriptionPlanList } from '@domains/subscription/priv/adapters/SubscriptionPlanList'
import { useNavigate } from 'react-router'

export const SubscriptionPlanPage = () => {
  const navigate = useNavigate()

  const onNavigateToTemplate = (templateId: string) => {
    navigate(`/subscription/${templateId}`)
  }

  return <SubscriptionPlanList navigateToTemplate={onNavigateToTemplate} />
}
